export default __webpack_public_path__ + "static/media/coverpage-03.57757f24.jpg";